<template>
	<!-- 客户管理 -->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock">
				<div class="public_criteriaRange customerManagementPC-select">
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty" style="width: 130px;">客户名称/昵称：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input style="padding-right: 10px;" maxlength="7"
									class="el-input__inner pulic_carNumber" type="text" placeholder="请输入客户名称/昵称"
									v-model="cusQueryName" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<input maxlength="11" class="el-input__inner pulic_carNumber" type="text"
									placeholder="请输入手机号" v-model="cusQueryiphone" />
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户等级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khdj" @clear="clearFun" clearable
							placeholder="请选择">
							<el-option v-for="item in khdjOperation" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
								:value="item.SETTB206CA00">
							</el-option>
						</el-select>
					</div>
					<div class="public_operatBtn" style="margin-left: 0px;">

						<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
							@click="querycusList()">
							<i class="iconfont icon-chaxun"></i>查询
						</el-button>

					</div>
				</div>

			</div>
			<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
				
				<el-table :data="tableData" @sort-change="onSortChange" height="580" style="width: 100%" stripe
					class="public_tableColumn"
					:header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
					<el-table-column prop="ORMTB410CA00" label="客户名称">
						<template slot-scope="scope">
							<p>
								<span>{{ scope.row.ORMTB410CA00 }}</span>
							</p>
							<p style="color: #999;">
								<span>{{ scope.row.ORMTB410CA02 }}</span>
							</p>

						</template>
					</el-table-column>
					<el-table-column prop="ORMTB410CA00" label="客户昵称">
						<template slot-scope="scope">
							<p>
								<span>{{ scope.row.ORMTB410CA10 }}</span>
							</p>


						</template>
					</el-table-column>
					<el-table-column prop="ORMTB410CA00" label="客户身份">
						<template slot-scope="scope">
							<p style="color: #FFCC00;" v-if="scope.row.ORMTB410CB03 == '1'">
								<span>发单人</span>
							</p>
							<p style="color: #FF6600;" v-if="scope.row.ORMTB410CB04 == '1'">
								<span>车主</span>
							</p>
							<p v-else>
								<span>普通用户</span>
							</p>
						</template>
					</el-table-column>

					<el-table-column prop="ORMTB410CA03" sortable label="可用余额"></el-table-column>
					<el-table-column prop="ORMTB410CA04" sortable label="冻结金额"></el-table-column>
					<el-table-column prop="ORMTB410CA05" sortable label="可提现金额"></el-table-column>
					<el-table-column v-if="preferentialType == 1" prop="ORMTB410CA06" sortable label="客户等级">
						<template slot-scope="scope">
							<p>
								<span>{{ scope.row.ORMTB410CA06Name }}</span>
							</p>
						</template>
					</el-table-column>

					<el-table-column label="操作">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn">


								<!-- <el-button @click="updateUserStatus(scope.row)" v-if="scope.row.ORMTB410CB00==1"
									type="error" class="public_icon_xiugai public_icon_width" size="small"
									style="color: red!important">禁用</el-button> -->
								<el-button @click="drzdClick(scope.row)" type="primary"
									class="public_icon_xiugai public_icon_width" size="small">导入账单
								</el-button>
								<el-button @click="drzdxqClick(scope.row)" type="primary"
									class="public_icon_chongzhi public_icon_width" size="small">详情
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<!-- </template> -->
				<!-- </RecycleScroller> -->
				<div class="customerManagementPC-page">
					<span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40, 100, 200]"
						layout="total, sizes,prev, pager, next" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>
			<div class="public-dialog">
				<el-dialog :title="zddrxqmsgobj.ORMTB410CA00+'账单导入详情'" :visible.sync="materShow" width="65%" @close="closezdtk"
					:closeOnClickModal='false'>
					<div class="public-chech systemCorporateAccount-dialog">
						<div class="">
							<div class="public-chech-details-tile">
								<div class="public-chech-details-tile-pre">厂家：</div>
								<div class="public-chech-details-tile-pre-sel"> 
									
									<el-select class="dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
										placeholder="请选择">
										<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99CA00"
											:label="item.SETTB99CA00" :value="item.SETTB99CA00">
										</el-option>
									</el-select>
									
									
								</div>
								<div class="public-chech-details-tile-q">操作时间：</div>
								<div class="public-chech-details-tile-q-sel">
									<el-date-picker v-model="nameMaterial" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
										start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</div>
								<el-button type="primary" style="margin-left: 20px;" @click="MaterialQuery">查询
								</el-button>
							</div>
							<div class="pulbic_oparetionBlock pulbic_table_container">
								<el-table :data="materList" style="width: 100%" stripe max-height="90%"
									class="public_tableColumn"
									:header-cell-style="{ color: 'rgba(51,51,51,1)', 'font-weight': 'bold' }">

									<el-table-column align="center" prop="ORMTB709CA00" label="操作时间"></el-table-column>
									<el-table-column align="center" prop="ORMTB709CA01" label="厂家"></el-table-column>
									<el-table-column align="center" prop="ORMTB709CA02" label="操作人"></el-table-column>
									<el-table-column align="center" label="操作" width="260">
										<template slot-scope="scope">

											<el-button class="public_icon_xiugai public_icon_width" type="info"
												size="small" @click="zdmxClick(scope.row)"  id="账单详情">
												账单详情
											</el-button>

										</template>
									</el-table-column>
								</el-table>
								<div class="pulbic_pagesize">
									<el-pagination @size-change="handleSizeChangeMaterial"
										@current-change="handleCurrentChangeMaterial"
										:current-page.sync="currentPageMaterial" :page-sizes="[10, 20, 30, 40]"
										:page-size="limitMaterial" layout="total,sizes, prev, pager, next"
										:total="pagingPageMaterial"></el-pagination>
								</div>
							</div>
						</div>
						<!-- <div class="public-dialog-btn">
							<el-button type="primary" @click="">保存</el-button>
							<el-button type="warning" @click="materShow=false">取消</el-button>
						</div> -->
					</div>
				</el-dialog>
			</div>

			
			<div class="public-dialog">
				<el-dialog :title="zddrxqmsgobj.ORMTB410CA00+'账单明细'" :visible.sync="saleWaterDetails" width="80%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false'>
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="tableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="ORMTB707CA11" label="ID">
								</el-table-column>
								<el-table-column prop="ORMTB707CA00" label="操作时间">
								</el-table-column>
								<el-table-column prop="ORMTB707CA05" label="厂家">
								</el-table-column>
								<el-table-column prop="ORMTB707CA06" label="物料">
								</el-table-column>
								<el-table-column prop="ORMTB707CA01" label="车牌号">
								</el-table-column>
								<el-table-column prop="ORMTB707CA02" label="净重">
								</el-table-column>
								<el-table-column prop="ORMTB707CA03" label="结算单价">
								</el-table-column>
								<el-table-column prop="ORMTB707CA04" label="结算金额">
								</el-table-column>
								<el-table-column prop="ORMTB707CA08" label="派单状态">
								</el-table-column>
								<el-table-column prop="ORMTB707CA09" label="结算状态">
								</el-table-column>
								<el-table-column prop="ORMTB707CA10" label="错误原因">
								</el-table-column>
								<el-table-column prop="ORMTB707CA07" label="操作人">
								</el-table-column>
								<!-- <el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargeTypeModify(scope.row)">修改
											</el-button>
											<el-button class="public_icon_jinyong public_icon_width" type="primary"
												size="small" v-if="scope.row.SETTB206CA02 == 1"
												@click="disableCus(scope.row, 0)">禁用</el-button>
											<el-button class="public_icon_qiyong public_icon_width" type="primary"
												size="small" v-if="scope.row.SETTB206CA02 == 0"
												@click="disableCus(scope.row, 1)">启用</el-button>
										</div>
									</template>
								</el-table-column> -->
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
								:current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]"
								:page-size="detailsPageLimit" layout="total,sizes, prev, pager, next"
								:total="detailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>
			
			<div class="public-dialog">
				<el-dialog title="导入账单" :visible.sync="CustomerfillingDig" width="40%" :closeOnClickModal='false' @close="closeDialog">
					<div style="max-height: 500px;overflow-y: auto;">
						<div class="CustomerfillingDig-tab">
							<el-upload ref="upload" accept=".xls,.xlsx" action="#" :auto-upload="false"
								:multiple="false" :file-list="fileList" :before-upload="beforeUpload"
								:http-request="uploadHttpRequest" :on-remove="fileRemove" :on-change="fileChange">
								<el-button size="small" type="primary">选择文件</el-button>
								<div slot="tip" class="el-upload__tip">一次只能上传一个xls/xlsx文件</div>
							</el-upload>

							<div class="CustomerfillingDig-tab-btn">
								<!-- @click="CZserve()" -->
								<el-button type="primary" @click="submitUpload()">提交</el-button>
								<el-button type="warning" @click="closeDialog">取消</el-button>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>
			
		</div>
	</div>
</template>

<script>
	// import {
	// 	Decimal
	// } from 'decimal.js';
	export default {

		data() {
			return {
				selectIndex: '',
				cellClickColumn: '',
				customerManagementList: '',
				customerManagementValue: '',
				customerManagement: false,
				customerManagementAdd: false,
				customerManagementAddName: '',
				customerManagemenUPObj: '',
				customerManagementUpdate: false,
				cusQueryName: '',
				cusQueryiphone: '',
				options: [],
				cusStatus: '',
				cusStatusList: [],
				tableData: [],
				flag: '',
				page: 1,
				pagesize: 10,
				currentPage: 1,
				count: 0,
				currentPage1: 1,
				detailsPageLimit: 10,
				detailsCount: 1,
				RechargetypeValue: '银行卡',
				RechargetypeOptions: [],
				CZRecordsDetails: [],
				CZRecordsPage: 1,
				CZRecordsPageLimit: 10,
				CZRecordsCount: 0,
				tableDataDetails: [],
				offerDetailsTab: [],
				ORMTB411ID: '',
				CustomerfillingDig: false,
				
				khdj: '全部',
				khdjOperation: [{
						value: '',
						label: '全部',
					}, {
						value: '0301',
						label: '一级客户',
					}, {
						value: '0302',
						label: '二级客户',
					}, {
						value: '0303',
						label: '三级客户',
					}, {
						value: '0304',
						label: '四级客户',
					}, {
						value: '0305',
						label: '五级客户',
					}, {
						value: '0306',
						label: '六级客户',
					}, {
						value: '0307',
						label: '七级客户',
					}, {
						value: '0308',
						label: '八级客户',
					},
					{
						value: '0309',
						label: '九级客户',
					}
				],
				

				tableDatayh: [],
				multipleSelection: [],
				CZmoney: '',
				Czmaxlength: 10, //充值限额
				CZremark: '',
				HCmoney: '',
				HCremark: '',
				HCamountCapitalText: '',
				amountCapitalText: '',
				cusInsertShow: false,
				yhInsertShow: false,
				ykblInsertShow: false,
				rowSelectFlag: false, // 禁止toggleRowSelection默认触发  @selection-change
				allChek: false,
				ruleForm: {},
				rules: {
					ORMTB410CB17: [{
						required: true,
						message: '请输入客户比例',
						trigger: 'change'
					}]
				},
				cusInsertObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusUpdateShow: false,
				cusUpdateObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusDJSetObj: {},
				freezeInsertShow: false,
				saleWaterDetails: false,
				rechargeTypeDig: false,
				rechargeTypeName: '',
				rechargeTypeUpOBJ: {
					SETTB206CA01: ''
				},
				rechargeTypeModifyDig: false,
				czRechargetypeShow: false,
				HCshow: false,
				HCObj: '',
				preferentialRecord: false,
				offerDetails: false,
				DetailsWater: false,
				deductionRecord: false,
				deductionRecordObj: '',
				deductionRecordtable: [],
				deductionRecordPage: 1,
				deductionRecordLimit: 10,
				deductionRecordCount: 0,
				DetailsWaterurl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				DetailsWatersrcList: [
					'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
					'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
				],

				// 账单导入详情
				materShow: false,
				materList: [],
				materiaShowZJ: '', //判断是否显示新增，修改，禁用按钮
				enterpriseTwo: '', //厂家
				enterpriseTwoName:'',//厂家名称
				nameMaterial: '', //物料名称
				pageMaterial: 1, //默认列表页码
				limitMaterial: 10, //每页的条数
				pagingPageMaterial: 0, //分页--数据列表共有的条数
				currentPageMaterial: 1, //设置当前页默认为1
				enterpriseTwoOptionList: [],
				zddrxqmsgobj: {},

				

				useryhmsg: {},

				enterNameMaterialModify: '', //企业名称
				nameMaterialModify: '', //物料名称
				wholesalePriceModify: '', //零售价格
				preferentialType: 0,
				solelist: [],
				cusUDJSetpdateShow: false,
				tableDataGradePre: [],
				innerVisible: false,
				
				yhCjShow: false, //返点厂家弹窗
				cjList: [],
				
				fdObj: {
					cjName: "",
					cjId: "",
					fdbl: "",
					wlName: "",
					wlId: "",
					wls: [],
					wlobjs: [],
					khName: "",
					khId: "",
					startTime: "",
					endTime: ""
				},
				wuliaoShow: false,

				fdmaterList: [],
				fdpageMaterial: 1, //默认列表页码
				fdlimitMaterial: 10, //每页的条数
				fdpagingPageMaterial: 0, //分页--数据列表共有的条数
				fdcurrentPageMaterial: 1, //设置当前页默认为1
				fdcjmsgobj: {},

				

				//返点调控
				fandianShow: false,
				fdList: [],
				fdListpageMaterial: 1, //默认列表页码
				fdListlimitMaterial: 10, //每页的条数
				fdListpagingPageMaterial: 0, //分页--数据列表共有的条数
				wuliaoShowTj: false,
				fdListTj: [],
				fdListpagingPageMaterialTj: 0,
				fdListlimitMaterialTj: 10, //每页的条数
				fdpageMaterialTj: 1,
				fdlimitMaterialTj: 10,
				shouQuanChangJiaShow: false, //授权厂家弹窗
				checkAllCj: false,
				checkedCitiesName: [],
				isIndeterminateCj: false,
				factoryList: [],
				checkedCitiesId: [],
				customerId: '',
				kyyepx: '',
				kyyepxOperation: [{
						label: '全部',
						value: ''
					},
					{
						label: '正序',
						value: 'ORMTB410CA05 ASC'
					}, {
						label: '倒序',
						value: 'ORMTB410CA05 DESC'
					}
				],
				fileList: []
			};
		},
		created() {
			var list = "";
			if (this.$route.query.mark != "" && this.$route.query.mark != null) {
				this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
				list = JSON.parse(sessionStorage.getItem("qpSolelist"));
				sessionStorage.removeItem('qpUobj');
				sessionStorage.removeItem('qpSolelist');
				this.quanpDisabled = true;
			} else {
				this.userobj = this.$store.state.uobj;
				list = this.$store.state.solelist;
				this.quanpDisabled = false;
			}
			var path = this.$route.path;
			if (path === "/SalesCustomer") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			// console.log(this.solelist)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			sessionStorage.removeItem(this.currentUrl);
			if (this.historyInfo != null && this.historyInfo != "") {
				this.init();
			}



		},
		mounted() {
			this.querycusList()
			// this.querypreferentialCode()
			this.khdjFun()
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				cusQueryName: this.cusQueryName, //客户名称
				cusQueryiphone: this.cusQueryiphone, //客户名称
				cusStatus: this.cusStatus, //客户状态
				currentPage: this.currentPage, //当前页数
				page: this.page, //页码
				pagesize: this.pagesize, //每页条数
			};
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
		},
		methods: {
			onSortChange({
				prop,
				order
			}) {
				// console.log(order)
				if (prop == 'ORMTB410CA06') {
					this.tableData.sort(this.compare(prop, order));
				}

			},
			
			handleSelectionChange(val) {
				// console.log(val)
				// if (this.rowSelectFlag) return
				this.multipleSelection = val;
			},
			MaterialQuery() {
				this.pageMaterial = 1
				this.pageMaterialList()

			},
			DiscountModify(item) {
				console.log(item)
				this.discountShow = true
				// this.queryMaterialTypeLsit('')
				this.MaterialModify109ID = item.SETTB109ID //物料ID
				this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
				this.nameMaterialModify = item.SETTB109CA00 //物料名称
				this.selectuserByPer()
			},
			
			// 获取下拉框信息--二级企业
			optionLists() {
				var postData = {
					type:1,
					SETTB100CA02: '' //用户类型
				}
				
				console.log(this.userobj.pertb005)
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					postData = {
						type:1,
						ORMTB400ID: this.userobj.ormtb410.ORMTB400ID //一级企业id
					}
				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					postData = {
						type:1,
						ORMTB400ID: this.userobj.ormtb400.ORMTB400ID //一级企业id
					}
				}
				
				// var List = [{
				// 	SETTB99ID: '',
				// 	SETTB99CA00: '',
				// }];
				var url = "/set/settb100/selectSettb100ByCa02";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						var data = res.data.data
						// 二级企业
						this.enterpriseTwoOptionList = data;
						if (this.enterpriseTwoOptionList.length == 2) {
							this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
							// console.log(this.enterpriseTwoOptionList[1])
							// this.enterpriseTwoName 
							
							// this.materielMoPost()
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					// this.pageList()
				}).catch(() => {
					// this.pageList()
					loading.close();
				})
			},
			
			materielMoPost() {//厂家查询
				var i = (this.enterpriseTwoOptionList || []).findIndex((profile) => profile.SETTB99ID === this
					.enterpriseTwo);
				var url = "/set/settb109/selectPageList";
				var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
				var data = {
					SETTB109CA03: '',
					SETTB109CA00: '',
					SETTB109CD01: SETTB100ID,
					SETTB99ID: this.enterpriseTwo,
					page: 1,
					limit: 1000,
				};
				var List = [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}];
				this.axios.post(url, data).then(res => {
					if (res.data.code == 200) {
						this.materielOptions = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			erpChange(e) {
				console.log(e)
				return
				
				if (this.enterpriseTwo != '') {
					this.materielMoPost()
				} 
				else {
					this.materielOptions = [{
						SETTB109CA00: '全部',
						SETTB109ID: '',
					}]
				}
			},
			closezdtk(){
				this.nameMaterial = ''
				this.enterpriseTwo = ''
			},
			//查询物料信息
			queryMaterialTypeLsit() {
				// console.log(type)
				// if (type === 0) {
				// 	this.materialTypeList = [{
				// 		SETTB206CA00: "",
				// 		SETTB206CA01: "全部"
				// 	}];
				// }
				// else {
				// 	this.materialTypeList = []
				// }
				this.materialTypeList = [{
					SETTB206CA00: "",
					SETTB206CA01: "全部"
				}];
				var url = "/set/settb109/selectSETTB206CA01"
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data
						this.materialTypeList = [...this.materialTypeList, ...data];
						// if (type === 0) {
						// 	this.materialTypeList = [...this.materialTypeList, ...data];
						// } else {
						// 	this.materialTypeList = data
						// }
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},

			//用户单个物料优惠调控
			selectuserByPer() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.rowkhId,
					SETTB109ID: this.MaterialModify109ID //物料ID

				}
				var url = "/set/settb109/selectByPer";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						console.log(res)

						if (res.data.data) {
							this.floatingAmount = res.data.data.SETTB418CA07 //浮动金额
							this.floatingType = JSON.stringify(res.data.data.SETTB418CA06) //浮动类型-上浮/下调
						} else {
							this.floatingAmount = '' //浮动金额
							this.floatingType = '' //浮动类型-上浮/下调
						}



						// this.$message({
						// 	message: res.data.message,
						// 	type: 'success'
						// });

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},


			preservationDiscountModify() {
				if (this.floatingType === '') return this.$message.error('请选择浮动类型')
				if (this.floatingAmount == undefined) return this.$message.error('请输入浮动金额')

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
					ORMTB410ID: this.rowkhId,
					SETTB109ID: this.MaterialModify109ID, //物料ID
					SETTB418CA06: this.floatingType, //上浮-下浮
					SETTB418CA07: this.floatingAmount //浮动金额

				}
				var url = "/set/settb109/updateByPer";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.discountShow = false;
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.pageMaterialList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},


			// 列表
			pageMaterialList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					startTime: this.nameMaterial[0], //开始时间
					endTime: this.nameMaterial[1], //结束时间
					ORMTB709CA01: this.enterpriseTwo,
					ORMTB410ID:this.zddrxqmsgobj.ORMTB410ID,
					page: this.pageMaterial,
					limit: this.limitMaterial
				}
				
				// console.log(this.nameMaterial)
				this.materList = [];
				var moList;
				var url = "/orm/ormtb440/selectPageListHis";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						moList = res.data.data;

						this.materList = moList;
						this.pagingPageMaterial = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			handleSizeChangeMaterial(val) {
				this.pageMaterial = 1
				this.limitMaterial = val;
				this.pageMaterialList();
			},
			// 点击页码
			handleCurrentChangeMaterial(val) {
				this.pageMaterial = val;
				this.pageMaterialList();
			},

			slmsgClick(row) {
				this.materShow = true
				this.cjmsgobj = row
				console.log(row)

				this.queryMaterialTypeLsit()
				this.pageMaterialList()
			},


			//提交客户优惠信息
			khyhserve() {

				if (this.multipleSelection.length == 0) {
					this.$message({
						message: '请选择数据',
						type: 'error'
					});
					return
				}

				var url = "/set/settb414/save"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.rowkhId,
					list: this.multipleSelection
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						this.yhInsertShow = false
						this.multipleSelection = []
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'error'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			khyhqx() {
				this.$refs.multipleTable.clearSelection();
				this.yhInsertShow = false
				this.multipleSelection = []

			},

			compare(propertyName, sort) {
				return function(obj1, obj2) {
					var value1 = obj1[propertyName];
					var value2 = obj2[propertyName];
					// console.log(value2)

					if (typeof value1 === "string" && typeof value2 === "string") {
						const res = value1.localeCompare(value2);
						return sort === "ascending" ? res : -res;
					} else {
						// if (value1 <= value2) {
						// 	return sort === "ascending" ? -1 : 1;
						// } else if (value1 > value2) {
						// 	return sort === "ascending" ? 1 : -1;
						// }
					}
				};
			},
			beforeUpload(file) {
				//文件类型
				const isType = file.type === 'application/vnd.ms-excel'
				const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				const fileType = isType || isTypeComputer
				if (!fileType) {
					this.$message.error('上传文件只能是xls/xlsx格式！')
				}

				// 文件大小限制为10M
				const fileLimit = file.size / 1024 / 1024 < 10;
				if (!fileLimit) {
					this.$message.error('上传文件大小不超过10M！');
				}
				return fileType && fileLimit
			},

			// 自定义上传方法，param是默认参数，可以取得file文件信息，具体信息如下图
			uploadHttpRequest(param) {
				const formData = new FormData() //FormData对象，添加参数只能通过append('key', value)的形式添加
				formData.append('file', param.file) //添加文件对象
				formData.append('ORMTB410ID', this.cusUpdateObj.ORMTB410ID)
				formData.append('ORMTB410CA00', this.cusUpdateObj.ORMTB410CA00)

				var url = "/orm/ormtb440/importJY"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				console.log(this.cusUpdateObj)

				var postData = {
					ORMTB410ID: this.cusUpdateObj.ORMTB410ID, //ID
					ORMTB410CA00: this.cusUpdateObj.ORMTB410CA00, // 用户名

				}
				this.axios.post(url, formData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.closeDialog()
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						// this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})

				
			},
			
			// 点击上传：手动上传到服务器，此时会触发组件的http-request
			submitUpload() {
				this.$refs.upload.submit()
			},
			// 文件发生改变
			fileChange(file, fileList) {
				if (fileList.length > 0) {
					this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
				}
			},
			// 移除选择的文件
			fileRemove(file, fileList) {
				if (fileList.length < 1) {
					this.uploadDisabled = true //未选择文件则禁用上传按钮
				}
			},
			// 取消
			closeDialog() {
				this.$refs.upload.clearFiles() //清除上传文件对象
				this.fileList = [] //清空选择的文件列表
				this.CustomerfillingDig = false;
				this.$emit('close', false)
			},

			
			
			
			

			



			//初始化数据
			init() {
				this.cusQueryName = this.historyInfo.cusQueryName;
				this.cusQueryiphone = this.historyInfo.cusQueryiphone;
				this.currentPage = this.historyInfo.currentPage;
				this.page = this.historyInfo.page;
				this.pagesize = this.historyInfo.pagesize;
				this.cusStatus = this.historyInfo.cusStatus
			},
			fullScreen() {
				//全屏
				var mark = 1;
				sessionStorage.setItem(
					"qpSolelist",
					JSON.stringify(this.$store.state.solelist)
				);
				sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

				let Logistics = this.$router.resolve({
					path: "/SalesCustomer",
					query: {
						mark: mark,
					},
				});
				this.$baseAPI.requestFullScreen(Logistics);
			},
			querycusList(dataFlag) {//查询用户信息
				this.tableData = []
				this.flag = dataFlag
				if (this.khdj == '全部') {
					this.khdj = ''
				}
				// this.count =0
				var url = "/orm/ormtb410/selectPageList"
				if (dataFlag) {
					this.page = ''
					this.pagesize = ''
				}
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					ORMTB410CA00: this.cusQueryName, //客户名称
					ORMTB410CA02: this.cusQueryiphone, //客户手机号
					ORMTB410CA06: this.khdj, //客户等级
					COL: this.kyyepx, //可用余额
					flag: dataFlag, //查询所有客户全部展示
					ORMTB410CB25:'1',
					page: this.page,
					limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data;
						this.count = res.data.count;

					}
					if (this.tableData.length > 0) {
						setTimeout(() => {
							loading.close()
						}, 300)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)

				}).catch(() => {
					loading.close()
				})
			},
			freezeSetClick() {
				this.freezeInsertShow = true
				this.cusSelect()
			},
			khdjFun() {
				this.khdjOperation = []
				var List = [{
					SETTB206CA00: '',
					SETTB206CA01: '全部',
				}];
				var url = "/set/settb500/selectLevel"
				// console.log(this.uobj)
				var postData = {
					// ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级代码ID
					// ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
					// ORMTB410ID:this.objyh.ORMTB410ID,
					// SETTB99ID:this.enterpriseTwo//二级企业ID
				}

				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data
						this.khdjOperation = [...List, ...data];
						// console.log(this.khdjOperation)
						// console.log(this.khdj)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			clearFun() {
				this.khdj = '全部'
			},
			cusSelect() {
				var url = "/orm/ormtb405/select"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableDataGradePre = res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
				this.page = 1;
				this.querycusList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.querycusList();
			},
			CZrecordClick(row) {
				// console.log(row)
				this.preferentialRecord = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
				this.CZrecordQuery()
			},
			ykblFun(row) {
				console.log(row)
				this.ykblInsertShow = true
				this.ruleForm = row
			},
			resetForm(formName) {
				// console.log(formName)
				this.ykblInsertShow = false;
				// this.$refs[formName].resetFields();

			},
			CZrecordQuery() {
				this.CZRecordsDetails = []
				// this.CZRecordsCount =0
				var url = "/orm/ormtb411/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
					page: this.CZRecordsPage,
					limit: this.CZRecordsPageLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.CZRecordsDetails = res.data.data;
						this.CZRecordsCount = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			offerDetailsClick(row) {
				this.offerDetails = true
				this.offerDetailsTab = []
				var url = "/orm/ormtb412/selectList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB411ID: row.ORMTB411ID,
					SETTB206CD01: this.userobj.pertb005.pertb005cd01,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.offerDetailsTab = res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			deductionRecordClick(row) {
				// console.log(row)
				this.deductionRecordtable = []
				// this.deductionRecordCount=0
				var url = "/orm/ormtb413/selectPageList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.ORMTB411ID = row.ORMTB411ID
				var postData = {
					ORMTB411ID: this.ORMTB411ID,
					page: this.deductionRecordPage,
					limit: this.deductionRecordLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.deductionRecordtable = res.data.data;
						this.deductionRecordCount = res.data.count
						this.deductionRecordtable.forEach(item => {
							if (item.ORMTB413CA02 == 'KK') {
								item.ORMTB413CA02Text = "扣款"
							} else if (item.ORMTB413CA02 == 'TK') {
								item.ORMTB413CA02Text = "退款"
							}
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			deductionRecordSizeChange(val) {
				this.deductionRecordLimit = val;
				this.deductionRecordPage = 1;
				this.deductionRecordClick();
			},
			deductionRecordCurrentChange(val) {
				this.deductionRecordPage = val;
				this.deductionRecordClick();
			},
			zdmxClick(row){
				this.saleWaterDetails =true
				this.zdmxval = row
				this.queryWayTypeQuery()
			},
			queryWayTypeQuery(row) {
				this.tableDataDetails = []
				// this.detailsCount=0
				var url = "/orm/ormtb440/selectPageListExcelLog"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.zddrxqmsgobj.ORMTB410ID,
					ORMTB707CA00: this.zdmxval.ORMTB709CA00,//操作时间
					page: this.currentPage1,
					limit: this.detailsPageLimit
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableDataDetails = res.data.data;
						this.detailsCount = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange1(val) {
				this.detailsPageLimit = val;
				this.currentPage1 = 1;
				// this.deductionRecordClick();
				this.queryWayTypeQuery()
			},
			handleCurrentChange1(val) {
				this.currentPage1 = val;
				// this.deductionRecordClick();
				this.queryWayTypeQuery()
			},
			saleWaterDetailsclose() {

			},
			CustomerfillingDigClose() {

			},
			cusInsertClose() {
				this.cusInsertObj = {
						ORMTB400ID: '',
						ORMTB410CA00: '',
						ORMTB410CA01: '',
						ORMTB410CA02: '',
						ORMTB410CA06: ''
					},
					this.multipleSelection = []
			},
			cusInsertServe() {
				if (this.cusInsertObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
				var reQ = /^1[3-9][0-9]{9}$/;
				if (!reQ.test(this.cusInsertObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
				if (this.preferentialType == 1) {
					if (this.cusInsertObj.ORMTB410CA06.length == 0) {
						return this.$message.error('请选择客户等级')
					}
				}
				var url = "/orm/ormtb410/insertOrmtb410"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.cusInsertObj
				postData.ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.querycusList()
						this.cusInsertShow = false
						this.cusInsertObj = {
							ORMTB400ID: '',
							ORMTB410CA00: '',
							ORMTB410CA01: '',
							ORMTB410CA02: '',
							ORMTB410CA06: '',
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusDJSetInsertServe() {
				var url = "/orm/ormtb405/update"
				var settb400List = []

				this.tableDataGradePre.forEach((resitme) => {
					settb400List.push(resitme)

				})
				var postData = {
					list: settb400List,
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.querycusList()
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.freezeInsertShow = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			upCusClose() {
				this.cusUpdateObj = {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				}
				this.CZmoney = ''
				this.wayTypeValue = 'CW'
				this.amountCapitalText = ''
			},
			CZTypeQuery() {
				this.RechargetypeOptions = []
				var url = "/orm/ormtb411/selectCzType/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.RechargetypeOptions = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			drzdClick(row) { //点击弹出导入账单弹框
				this.CustomerfillingDig = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
				// this.RechargetypeValue = "银行卡"
				// this.CZTypeQuery()
			},
			drzdxqClick(row) { //点击弹出导入账单详情
				this.materShow = true;
				this.zddrxqmsgobj = row
				this.optionLists();
				this.pageMaterialList();
				console.log(row)
			},
			innerVisibleClick() {
				if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
				if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
				if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')

				if (!this.CZremark) {
					this.$message.error('请填写备注')
				} else {
					this.innerVisible = true
				}
			},
			
			HCclick(row) { //点击红冲
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
				this.HCshow = true
			},

			HCserve() {
				if (!this.HCmoney) return this.$message.error('请输入红冲金额');
				if (!this.HCremark) return this.$message.error('请输入备注');
				// if (this.HCmoney > this.cusUpdateObj.ORMTB410CA03) return this.$message.error('红冲金额不可大于余额');
				var url = "/orm/ormtb411/hc"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
					ORMTB420CA02: this.HCmoney,
					ORMTB420CA08: this.HCremark
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`红冲成功`)
						this.HCshow = false
						this.querycusList()
						this.HCremark = ''
						this.HCmoney = ''
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			upuserClick(row) {
				if (this.preferentialType == 1) {
					this.customerManagementQuery()
				}
				this.cusUpdateShow = true
				var str = JSON.stringify(row)
				this.cusUpdateObj = JSON.parse(str)
			},
			upDJSetuserClick(row) {
				this.cusUDJSetpdateShow = true
				var str = JSON.stringify(row)
				this.cusDJSetObj = JSON.parse(str)
				// console.log(this.cusDJSetObj)
			},
			yhSetuserClick(row) {
				// console.log(row)
				this.yhInsertShow = true
				this.useryhmsg = row
				this.rowkhId = row.ORMTB410ID
				this.cjkhyhset(row.ORMTB410ID)

			},
			fdFun(row) {
				this.yhCjShow = true
				this.useryhmsg = row
				this.changjiaList()
				this.fdObj.khName = row.ORMTB410CA10
				this.fdObj.khId = row.ORMTB410ID
			},
			cjkhyhset(data) {
				var url = "/set/settb414/list"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: data
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						this.tableDatayh = res.data.data
						this.selectData()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusADD() {
				if (this.preferentialType == 1) {
					this.customerManagementQuery()
				}
				this.cusInsertShow = true
			},
			cusUpdateServe() {
				if (this.cusUpdateObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
				var reQ = /^1[3-9][0-9]{9}$/;
				if (!reQ.test(this.cusUpdateObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
				if (this.preferentialType == 1) {
					if (this.cusUpdateObj.ORMTB410CA06.length == 0) {
						return this.$message.error('请选择客户等级')
					}
				}
				var url = "/orm/ormtb410/updateOrmtb410ById"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.cusUpdateObj
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.querycusList()
						this.cusUpdateShow = false
						this.cusUpdateObj = {
							ORMTB400ID: '',
							ORMTB410CA00: '',
							ORMTB410CA01: '',
							ORMTB410CA02: '',
							ORMTB410CA06: ''
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusDJSetdateServe() {

				if (!this.cusDJSetObj.ORMTB410CB07) return this.$message.error('请输入冻结倍数')

				var url = "/orm/ormtb410/updateORMTB410CB07"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});

				var postData = {
					ORMTB410ID: this.cusDJSetObj.ORMTB410ID,
					ORMTB410CB07: this.cusDJSetObj.ORMTB410CB07
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('设置成功')
						this.querycusList()
						this.cusUDJSetpdateShow = false

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechargeTypeModify(row) {
				this.rechargeTypeModifyDig = true
				var str = JSON.stringify(row)
				this.rechargeTypeUpOBJ = JSON.parse(str)
			},
			disableCus(row, type) {
				var str = type == 1 ? '启用' : '禁用'
				this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url = "/orm/ormtb410/updataCzType"
					var loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					// console.log(this.userobj)
					var postData = {
						SETTB206CA01: '',
						SETTB206ID: row.SETTB206ID,
						SETTB206CA02: type,
					}
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.$message.success(`${str}成功`)
							this.queryWayTypeQuery()
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					}).catch(() => {
						loading.close()
					})
				})
			},
			rechargeTypeAdd() {
				this.rechargeTypeDig = true
			},
			rechargeTypeModifyClose() {
				this.rechargeTypeUpOBJ = {
					SETTB206CA01: ''
				}
			},
			
			customerManagementQuery() {
				this.customerManagementList = []
				var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.customerManagementList = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			customerManagementAddServe() {
				if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/set/settb206/insertVIP "
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.customerManagementAddName,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.customerManagementQuery()
						this.customerManagementAdd = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cusUpdataClick(row) {
				this.customerManagemenUPObj = row
				this.customerManagemenUPObj.oldname = row.SETTB206CA01
				this.customerManagementUpdate = true
			},
			customerManagementUpdateServe() {
				if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01) return this.$message
					.error('请修改名称')
				if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/set/settb206/updateVIP"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
					SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.customerManagementQuery()
						this.customerManagementUpdate = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechaTypePreser() {
				if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/orm/ormtb410/addCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.rechargeTypeName,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.queryWayTypeQuery()
						this.rechargeTypeDig = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechaTypePreserModify() {
				if (this.rechargeTypeUpOBJ.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: this.rechargeTypeUpOBJ.SETTB206CA01,
					SETTB206ID: this.rechargeTypeUpOBJ.SETTB206ID,
					SETTB206CA02: this.rechargeTypeUpOBJ.SETTB206CA02,
					SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.queryWayTypeQuery()
						this.rechargeTypeModifyDig = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			DetailsWaterClick(item) {
				// console.log(item)
				if (!item.ORMTB440CA00) {
					this.$message({
						message: '未查询到订单',
						type: 'error'
					});
					return
				}
				this.DetailsWater = true
				this.deductionRecordDetileQuery(item)
			},
			deductionRecordDetileQuery(row) {
				this.deductionRecordObj = ''
				this.DetailsWatersrcList = []
				this.DetailsWaterurl = ''
				var url = "/orm/ormtb440/selectDetails"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					ORMTB440ID: row.ORMTB413CA03,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.deductionRecordObj = res.data.data
						this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
						this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			CZRecordsSizeChange(val) {
				this.pagesize = val;
				this.page = 1;
				this.CZrecordQuery();
			},
			CZRecordsCurrentChange(val) {
				this.page = val;
				this.CZrecordQuery();
			},

			HCMoneyInput() {
				this.HCmoney = this.HCmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.HCmoney = this.HCmoney.replace(/^\./g, ""); //验证第一个字符是数字
				this.HCmoney = this.HCmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.HCmoney = this.HCmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				this.HCmoney = this.HCmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (this.HCmoney.indexOf(".") < 0 && this.HCmoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.HCmoney = parseFloat(this.HCmoney);
				}
				this.HCmoney = this.HCmoney > 10000000 ? 10000000 : this.HCmoney
				// this.$refs.HCmoney.value = this.HCmoney
				this.HCamountCapitalText = this.priceChange(this.HCmoney)
			},
			HCMoneyChange() {
				var index = String(this.HCmoney).indexOf('.')
				if (index == -1) return
				var numArr = this.HCmoney.split('.')
				if (numArr[1].length == 0) {
					this.$refs.HCmoney.value = numArr[0]
					this.HCmoney = numArr[0]
				} else {
					this.$refs.HCmoney.value = numArr[0] + '.' + numArr[1]
					this.HCmoney = numArr[0] + '.' + numArr[1]
				}
			},
			topMoneyInput() { //充值金额实时校验
				// console.log(this.CZmoney)
				this.CZmoney = this.CZmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				this.CZmoney = this.CZmoney.replace(/^\./g, ""); //验证第一个字符是数字
				this.CZmoney = this.CZmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				this.CZmoney = this.CZmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (this.CZmoney.indexOf(".") < 0 && this.CZmoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.CZmoney = parseFloat(this.CZmoney);
				}
				this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
				// this.$refs.topMoney.value = this.CZmoney
				this.amountCapitalText = this.priceChange(this.CZmoney)

			},
			priceChange(number) {
				var ret = "";
				if (number != "" && number != null && number != "0") {
					var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
						str = "";
					number += "00";
					var point = number.indexOf(".");
					if (point >= 0) {
						number = number.substring(0, point) + number.substr(point + 1, 2);
					}
					unit = unit.substr(unit.length - number.length);
					for (var i = 0; i < number.length; i++) {
						str += "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
					}
					ret =
						str
						.replace(/零(仟|佰|拾|角)/g, "零")
						.replace(/(零)+/g, "零")
						.replace(/零(万|亿|元)/g, "$1")
						.replace(/(亿)万|(拾)/g, "$1$2")
						.replace(/^元零?|零分/g, "")
						.replace(/元$/g, "元");
				}
				return ret;
			},
			topMoneyChange() { //充值金额失去焦点数据处理
				var index = String(this.CZmoney).indexOf('.')
				if (index == -1) return
				var numArr = this.CZmoney.split('.')
				if (numArr[1].length == 0) {
					this.$refs.topMoney.value = numArr[0]
					this.CZmoney = numArr[0]
				} else {
					this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
					this.CZmoney = numArr[0] + '.' + numArr[1]
				}
			},
			changjiaList(data) {
				var url = "/set/settb100/selectSettb100ByCa02"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						console.log(res)
						this.cjList = res.data.data
						//this.selectData()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			openWuliaoClick(row) {
				this.wuliaoShow = true
				this.fdcjmsgobj = row
				this.fdObj.khId = row.ORMTB410ID
				this.fdObj.khName = row.ORMTB410CA00
				this.changjiaList()
				this.fdListFun()
				//查询返点列表
			},

		


			/*根据厂家查物料*/
			fdPageMaterialList() {
				//this.fdObj.wlName = ""


				if (this.hanshuijiaShow == true) { //查看厂家物料含税价和不含税价

					console.log(this.objuserMsg)

					this.selectwlhxPageListFun()


				} else {
					this.fdObj.wlId = ""
					console.log(JSON.stringify(this.uobj))
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					var postData = {
						SETTB99ID: this.fdObj.cjId,
						SETTB109CD01: "",
						limit: "1000",
						page: "1"
					}
					this.materList = [];
					var fdmoList;
					var url = "set/settb109/selectPageList";
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						setTimeout(() => {
							loading.close()
						}, 300)
						if (res.data.code == 200) {
							fdmoList = res.data.data;
							this.fdmaterList = fdmoList;
							this.fdpagingPageMaterial = res.data.count;
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					}).catch(() => {
						loading.close();
					})
					this.onSelecteLableCj()
				}


			},
			
			commitFdModify() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB420CA00: this.fdObj.cjName,
					SETTB420CA01: this.fdObj.cjId,
					SETTB420CA02: this.fdObj.wlName,
					SETTB420CA03: this.fdObj.wlId,
					SETTB420CA04: this.fdObj.khName,
					SETTB420CA05: this.fdObj.khId,
					SETTB420CA07: this.fdObj.fdbl,
					SETTB420CA09: this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.fdObj.startTime)),
					SETTB420CA10: this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.fdObj.endTime)),
					WLOBJS: this.fdObj.wlobjs
				}
				var url = "set/settb420/save";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.fandianShow = false
						this.fdListFun()
						this.$message({
							message: '保存成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: '保存失败',
							type: 'error'
						});
						this.fandianShow = false
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			commitVerify() {
				if (this.fdObj.cjName.trim().length == 0) return this.$message.error('请选择厂家')
				if (this.fdObj.fdbl.toString().trim().length == 0) return this.$message.error('请输入返点比率')
				if (this.fdObj.startTime.length === 0) return this.$message.error('请选择开始时间')
				if (this.fdObj.endTime.length === 0) return this.$message.error('请选择结束时间')
				if (!/^-?\d+(\.\d+)?$/.test(this.fdObj.fdbl)) {
					return this.$message.error('请输入有效的返点比率')
				}
				if (this.fdObj.startTime >= this.fdObj.endTime) {
					return this.$message.error('结束时间需大于开始时间')
				}
				if (this.fdObj.wlobjs.length == 0) {
					this.$confirm('不选择物料将对所有物料进行设置, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.commitFdModify()
					}).catch(() => {});
				} else {
					this.commitFdModify()
				}
			},
			fdhandleSizeChangeMaterial(val) {
				this.fdpageMaterial = 1
				this.fdlimitMaterial = val;
				this.fdListFun();
			},
			// 点击页码
			fdhandleCurrentChangeMaterial(val) {
				this.fdpageMaterial = val;
				this.fdListFun();
			},
			
			onSelecteLable() {
				const idSet = new Set(this.fdObj.wls);
				this.fdObj.wlobjs = this.fdmaterList.filter(item => idSet.has(item.SETTB109ID));

			},
			onSelecteLableCj() {
				let obj = {};
				obj = this.cjList.find(item => {
					//这里的userList就是上面遍历的数据源
					return item.SETTB99ID === this.fdObj.cjId; //筛选出匹配数据
				});
				this.fdObj.cjName = obj.SETTB99CA00
			},
			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份
					"d+": date.getDate(), //日
					"h+": date.getHours(), //小时
					"m+": date.getMinutes(), //分
					"s+": date.getSeconds(), //秒
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度
					"S": date.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},
			deleteFd(item) {
				var postData = {
					SETTB420ID: item.SETTB420ID
				}
				this.$confirm('确定要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					var url = "set/settb420/delete";
					this.axios.post(url, postData).then(res => {
						setTimeout(() => {
							loading.close()
						}, 300)
						if (res.data.code == 200) {
							this.fdListFun()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					}).catch(() => {
						loading.close();
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			openWuliaoClickTj(row) {
				this.wuliaoShowTj = true
				this.fdObj.khId = row.ORMTB410ID
				this.fdListFunTj()
			},
			// 打开授权厂家弹窗
			openShouQuanChangJia(row) {
				this.customerId = row.ORMTB410ID;
				this.checkedCitiesName = [];
				this.checkedCitiesId = [];
				this.factoryList = [];
				this.isIndeterminateCj = false;
				this.checkAllCj = false;
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB706CA00: row.ORMTB410ID,
				}
				var url = "orm/ormtb706/selectSettb100ByCa02V2";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.checkedCitiesName = res.data.data.filter(item => item.check == 1).map(item => item
							.SETTB99CA00);
						this.checkedCitiesId = res.data.data.filter(item => item.check == 1).map(item => item
							.SETTB99ID);
						this.factoryList = res.data.data;
						this.checkAllCj = this.checkedCitiesName.length == this.factoryList.length ? true : false;
						this.isIndeterminateCj = this.checkedCitiesName.length > 0 && this.checkedCitiesName
							.length < this.factoryList.length;
						this.shouQuanChangJiaShow = true;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			/*返点统计列表*/
			fdListFunTj() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB420CA05: this.fdObj.khId,
				}
				var url = "set/settb420/count";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.fdListTj = res.data.data
						this.fdListpagingPageMaterialTj = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			fdhandleSizeChangeMaterialTj(val) {
				this.fdpageMaterialTj = 1
				this.fdlimitMaterialTj = val;
				this.fdListFunTj();
			},
			// 点击页码
			fdhandleCurrentChangeMaterialTj(val) {
				this.fdpageMaterialTj = val;
				this.fdListFunTj();
			},
			clearFunWl() {
				this.fdObj.wlId = ""
				this.fdObj.wlName = ""
			}
		}
	};
</script>

<style scoped>
	.carDialogTitle {
		font-weight: bold;
		line-height: 60px;
		color: rgb(0, 163, 255);
	}

	.customerManagementPC {
		background-color: #f3f3f3;
	}

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 100px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
		margin-left: 0;
	}

	.customerManagementPC-btn {
		text-align: left;
		margin-bottom: 20px;
	}

	.customerManagementPC-btn i {
		margin-right: 10px;
	}

	.customerManagementPC-table {
		padding: 30px 20px 0;
	}

	.customerManagementPC-table-btn i {
		font-size: 12px;
		margin-right: 5px;
	}

	.customerManagementPC-add-customer {
		padding-left: 20px;
	}

	.customerManagementPC-add-customer-li {
		display: flex;
		text-align: center;
		font-size: 16px;
		height: 42px;
		line-height: 42px;
	}

	.customerManagementPC-add-customer-li>div {
		border: 1px solid #cdcdcd;
		border-top: none;
	}

	.customerManagementPC-add-customer-li:first-child>div {
		border-top: 1px solid #cdcdcd;
	}

	.customerManagementPC-add-customer-li>div:first-child {
		border-right: none;
	}

	.customerManagementPC-add-customer-li>div:last-child {
		border: none;
		color: #ff4d35;
	}

	.customerManagementPC-add-customer-li-name {
		flex: 1;
	}

	.customerManagementPC-add-customer-li-ipt {
		flex: 1;
		box-sizing: border-box;
	}

	.customerManagementPC-add-customer-li-ipt input {
		border: none;
		outline: none;
		width: 100%;
		height: 37px;
		box-sizing: border-box;
		vertical-align: top;
		padding-left: 5px;
		text-align: center;
		font-size: 16px;
	}

	.customerManagementPC-add-customer-li-type {
		flex: 0.3;
	}

	.customerManagementPC-add-customer-btn {
		text-align: center;
		margin: 30px 0 20px 0;
	}

	.public-chech-details-table {
		margin-top: 20px;
		max-height: 500px;
		overflow-y: auto;
	}

	.public-chech-details-table-no-text {
		line-height: 80px;
		text-align: center;
		border-bottom: 1px solid #cdcdcd;
	}

	.customerManagementPC-page {
		margin-top: 20px;
		text-align: right;
	}

	.CustomerfillingDig-priceNumtext {
		font-weight: 500;
		font-size: 18px;
		line-height: 40px;
		padding: 20px 0 20px 10px;
		color: #333;
	}

	.CustomerfillingDig-priceNumtext span {
		color: rgba(175, 181, 4, 1.0);
		margin-left: 10px;
		font-size: 20px;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord-border {

		/* border-top: 2px solid rgba(205,205,205,.4); */
		border-top: none;
		box-sizing: border-box;
		margin-right: 40px;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center;
	}

	.customerRecharge-table {
		box-sizing: border-box;
	}

	.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
		border-color: rgba(254, 172, 0, 1) !important;
	}

	.CustomerfillingDig-tab {
		padding-left: 20px;
	}

	.CustomerfillingDig-tab-li,
	.rechargeType-tab-li {
		display: flex;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 16px;
		color: #333;
		vertical-align: top;
	}

	.CustomerfillingDig-tab-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}

	.CustomerfillingDig-tab-li>div:first-child {
		border-right: none;
	}

	.CustomerfillingDig-tab-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}

	.CustomerfillingDig-tab-li>div:last-child,
	.rechargeType-tab-li>div:last-child {
		border: none;
		color: #FF4D35;
	}

	.CustomerfillingDig-tab-li-text {
		flex: .8;
		background: rgba(240, 252, 255, 1);
	}

	.CustomerfillingDig-tab-li-ipt {
		flex: .8;
	}

	.rechargeType-tab-li-text {
		flex: .35;
	}

	.rechargeType-tab-li-ipt {
		flex: .7;
	}

	.CustomerfillingDig-tab-li-ipt input,
	.rechargeType-tab-li-ipt input {
		height: 46px;
		width: 100%;

		text-align: center;

		box-sizing: border-box;
		font-size: 16px;
		color: #333;
	}

	.CustomerfillingDig-tab-li-ipt input {
		outline: none;
		border: none;
		vertical-align: top;
	}

	.rechargeType-tab-li-ipt input {
		/* border-radius: 8px; */
		/* outline: none; */
	}

	.CustomerfillingDig-tab-li-b,
	.rechargeType-tab-li-b {
		flex: .3;
	}

	.CustomerfillingDig-tab-btn {
		text-align: center;
		margin-top: 30px;
	}

	.rechargeType-tab-btn {
		margin-top: 80px !important;
	}

	.billOperationRecord-page {
		padding-right: 40px;
		text-align: right;
		margin-top: 20px;
		padding-bottom: 20px;
	}

	.salesWatersStatisticsPC-saleWaterDetails-btn {
		margin-bottom: 20px;
	}

	.salesWatersStatisticsPC-saleWaterDetails-btn i {
		margin-right: 10px;
	}

	.el-dropdown-link {
		cursor: pointer;
	}

	.el-table--scrollable-y .el-table__body-wrapper {
		overflow: auto;
	}

	.public_tableColumn .el-table__body-wrapper {
		overflow: auto !important;
	}

	.public_icon_width {
		width: 80px;
	}

	.levelmang-title {
		display: flex;
		color: #333;
		text-align: center;
		margin-bottom: 20px;

	}

	.levelmang-title div {
		padding: 10px 20px;
		background-color: #e3e3e3;
	}

	.levelmang-title .levelmang-title-active {
		background-color: #199FFF;
		color: #FFF;
	}

	.levelmang-table {
		border: 1px solid #e3e3e3;
	}

	.levelmang-table>li {
		display: flex;
	}

	.levelmang-table-head {
		text-align: center;
		background-color: #30A8FF;
		color: #FFF;
	}

	.levelmang-table-head>div {
		height: 50px;
		line-height: 50px;
		border-left: 1px solid #e3e3e3;
		box-sizing: border-box;
		overflow: hidden;
	}

	.levelmang-table-head>div:first-child {
		border: none;
	}

	.levelmang-table-CQ {
		flex: 1;
		position: relative;
		padding: 5px 10px;
	}

	.levelmang-table-CQ-list {
		border-bottom: 1px solid #e3e3e3;
	}

	.levelmang-table-JB {
		width: 240px;
	}

	.levelmang-table-KJ,
	.levelmang-table-ZK,
	.levelmang-table-YH {
		width: 295px;
	}

	.levelmang-table-ZK input,
	.levelmang-table-YH input {
		text-align: center;
	}

	.levelmang-table-li {
		text-align: center;
	}

	.levelmang-table-li-tab-li {

		border-bottom: 1px solid #e3e3e3;
	}

	.levelmang-table-li-tab-li:last-child {
		/* border: none; */
	}

	.levelmang-table-li-tab-li>div {
		border-left: 1px solid #e3e3e3;
		padding: 0 10px;
		box-sizing: border-box;
		height: 50px;
		line-height: 50px;
		vertical-align: top;
		overflow: hidden;
	}

	.levelmang-table-li-tab-li>div>input {
		width: 100px;
		border: 1px solid #e3e3e3;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		margin-right: 10px;
	}

	.levelmang-table-CQ>div {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 100%;
		transform: translate(-50%, -50%);
	}

	.levelmang-table-li-tab-li {
		display: flex;
	}


	.systemCorporateAccount-dialog {
		padding: 0 20px;
	}

	.systemCorporateAccount-dialog-li {
		display: flex;
		box-sizing: border-box;
	}

	.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li {
		margin-top: 20px;
	}

	.systemCorporateAccount-dialog-btn {
		text-align: center;
		margin-top: 40px;
	}

	.systemCorporateAccount-wuliao-input>input {
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding-left: 5px;
	}

	.SCADL-text {
		height: 30px;
		line-height: 30px;
		flex: .35;
		font-size: 18px;
		color: #333;
	}

	.SCADL-text span {
		color: red;
	}

	.SCADL-input {
		flex: 1;
		box-sizing: border-box;
	}

	.SCADL-input input {
		height: 40px;
		line-height: 30px;
		width: 99.9%;
		padding-left: 10px;
		border: 1px solid #999;
		color: #333;
		font-size: 18px;
		border-radius: 5px;
		box-sizing: border-box;
	}

	.SCADL-input .el-input {
		font-size: 18px;
	}

	.num {
		color: #333;
		font-size: 18px;
	}

	.cJ-btn {
		margin-top: 20px;
	}

	.shouQuanChangJia-dialog .el-checkbox {
		margin-bottom: 15px;
	}

	/deep/ .num .el-input .el-input__inner {
		font-size: 18px !important;
	}

	::v-deep .addPointer {
		cursor: pointer;
	}

	::v-deep .success-row {
		background-color: #81d3f8 !important;
	}
</style>